<template>
  <dl
    class="inputDataPreview"
    :class="{ '-boder-none': !hasBorder }"
    v-if="contentHtml.length > 0"
  >
    <dt>{{ label }}</dt>
    <dd v-html="contentHtml"></dd>
  </dl>
</template>

<script lang="ts">
import { computed } from 'vue'

export default {
  name: 'PreviewPairData',

  props: {
    label: String,
    content: String,
    hideEmptyContent: {
      type: Boolean,
      default: false
    },
    hasBorder: {
      type: Boolean,
      default: true
    }
  },

  setup(props: any) {
    const contentHtml = computed(() => {
      if (props.content || props.hideEmptyContent) return props.content
      return '－'
    })

    return {
      contentHtml
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.inputDataPreview {
  padding-bottom: 17px;
  border-bottom: 1px solid var.$color-border-gray;
  line-height: 1.42;

  &.-boder-none {
    border-bottom: none;
    padding-top: 17px;
  }

  &.-mypage:first-of-type {
    dd {
      width: 70%;
    }
  }

  @include mixins.media() {
    display: flex;
    padding-top: 8px;
    padding-bottom: 20px;

    &.-boder-none {
      padding-top: 20px;
    }
  }

  & + & {
    margin-top: 25px;

    @include mixins.media() {
      padding-top: 20px;
      margin-top: 0;
    }
  }

  > dt {
    color: #c6c6c6;

    @include mixins.media() {
      flex-shrink: 0;
      flex-basis: 190px;
    }
  }

  > dd {
    margin-top: 5px;
    white-space: pre-wrap;

    @include mixins.media() {
      margin-top: 0;
    }
  }

  .headingLv4 + & {
    margin-top: 14px;
  }
}

::v-deep(.notes) {
  margin-top: 16px;
  display: block;
  font-size: 1.2rem;
}
</style>
